<template>
  <div class="row u-align-items-center u-justify-content-flex-end">
    <div
      class="es-xs-12 es-md-6 es-lg-4 u-padding-right-xsmall es-xl-4 u-margin-bottom-small-md-down"
    >
      <ProjectSearch
        :value="filter.projectId"
        :label="$t('batteries.project')"
        no-label
        searchable
        @input="SET_FILTER('projectId', $event)"
      ></ProjectSearch>
    </div>
    <div
      class="es-xs-12 es-md-6 es-lg-4 u-padding-right-xsmall u-padding-left-xsmall es-xl-4 u-margin-bottom-small-md-down"
    >
      <user-search
        :value="filter.user"
        @input="SET_FILTER('user', $event)"
      ></user-search>
    </div>
    <div
      class="es-xs-12 es-md-6 es-lg-4 u-padding-left-xsmall es-xl-4 u-margin-bottom-small-md-down"
    >
      <div class="btn-group-container u-justify-content-flex-end">
        <Button
          group-item
          block
          v-tooltip="$t('filter.allTooltipMessage')"
          :variant="`${filter.isLocked === null ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
          @click="SET_FILTER('isLocked', null)"
        >
          {{ $t("filter.all") }}
        </Button>
        <Button
          group-item
          block
          v-tooltip="$t('filter.isLockedTooltipMessage')"
          :variant="`${filter.isLocked ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
          @click="SET_FILTER('isLocked', true)"
        >
          <i class="icofont-ui-lock"></i> {{ $t("common.lockedText") }}
        </Button>
        <Button
          group-item
          block
          v-tooltip="$t('filter.isUnLockedTooltipMessage')"
          @click="SET_FILTER('isLocked', false)"
          :variant="`${filter.isLocked === false ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
        >
          <i class="icofont-ui-unlock"></i> {{ $t("common.unlockedText") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../Base/Button.vue";
import UserSearch from "../Searches/UserSearch.vue";
import ProjectSearch from "../Searches/ProjectSearch.vue";
export default {
  components: {
    Button,
    ProjectSearch,
    UserSearch,
  },
  data() {
    return {
      filter: {
        isLocked: null,
        user: null,
        projectId: null,
      },
    };
  },
  methods: {
    SET_FILTER(key, value) {
      this.filter[key] = value;
      this.$emit("change:filter", this.filter);
    },
  },
};
</script>

<style></style>
